/**
 * Platform-wide feature flags read from build-time env (Vue CLI 5 / Webpack 5).
 *
 * Webpack DefinePlugin replaces *static* `process.env.VUE_APP_*` accesses with
 * the literal value at build time. Dynamic lookups (`env[name]`) don't work in
 * the browser bundle — `process.env` isn't a runtime global. Every flag below
 * gets its own static branch.
 *
 * Defaults are `true` (fail-open): if the env var is missing or empty, the
 * feature stays visible. Set the corresponding `VUE_APP_*_ENABLED=false` in
 * the deployment env to hide a catalog.
 */
function readBoolWithDefault(value: string | undefined, defaultValue: boolean): boolean {
    if (value === undefined || value === '') return defaultValue;
    return String(value).toLowerCase() === 'true';
}

export function mentorsCatalogEnabled(): boolean {
    return readBoolWithDefault(process.env.VUE_APP_MENTORS_CATALOG_ENABLED, true);
}

export function eventsCatalogEnabled(): boolean {
    return readBoolWithDefault(process.env.VUE_APP_EVENTS_CATALOG_ENABLED, true);
}

/**
 * P1-2: фича «перенос консультации наставником» (E2 mentor-reschedule).
 * В отличие от каталожных флагов — fail-closed (дефолт `false`): BE-эндпоинты
 * переноса (`/consultation-bookings/…/propose-reschedule/` и пр.) запаркованы
 * за `FEATURE_MENTOR_RESCHEDULE` (на проде False) и отвечают 404 — активная
 * CTA «Перенести» без флага вела в гарантированную ошибку. Включать
 * `VUE_APP_MENTOR_RESCHEDULE_ENABLED=true` синхронно с BE-флагом.
 */
export function mentorRescheduleEnabled(): boolean {
    return readBoolWithDefault(process.env.VUE_APP_MENTOR_RESCHEDULE_ENABLED, false);
}

/**
 * Late-start grace в минутах. Должно совпадать с `SESSION_GRACE_MIN` на BE —
 * после стольких минут от planned_start_at без захода наставника beat-task
 * `enforce_late_start_guard` помечает сессию LATE_CANCELED и инициирует
 * авто-рефанд. FE использует это значение, чтобы:
 *  • показывать «прошедшее» в календаре синхронно с BE-решением;
 *  • подставлять корректное число в тексты «не подключился в течение N минут».
 */
function readPositiveIntWithDefault(value: string | undefined, defaultValue: number): number {
    const parsed = Number(value);
    if (!Number.isFinite(parsed) || parsed <= 0) return defaultValue;
    return Math.floor(parsed);
}

export function sessionGraceMin(): number {
    return readPositiveIntWithDefault(process.env.VUE_APP_SESSION_GRACE_MIN, 20);
}
